import { render, staticRenderFns } from "./KimsaTextField.vue?vue&type=template&id=1e42d806&scoped=true"
import script from "./KimsaTextField.vue?vue&type=script&lang=js"
export * from "./KimsaTextField.vue?vue&type=script&lang=js"
import style0 from "./KimsaTextField.vue?vue&type=style&index=0&id=1e42d806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e42d806",
  null
  
)

export default component.exports